// Capitalizes first letter of word
export function ucFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// Capitalize the first letter in a string, similar to PHP's ucfirst function
export function ucWords(str) {
  if (!str || str == "" || str == undefined) return ""
  let ret = ''
  str.split(' ').forEach(i => {
    ret += ucFirst(i.toLowerCase()) + ' '
  })
  return ret.trim()
}

